<template>
  <div>
    <div id="backgroundart"></div>
    <div class="donate">
      <a href="https://tucsonpathways.org"><div id="logo">Tp</div></a>

      <div class="title">
        please consider supporting
        <!-- our goal is simple. <span>create commuters.</span> -->
        <!-- <h5>through modern analytics, messaging, </h5> -->
      </div>
      <!-- <div class="chunk">
        <h3>Why We Need Help</h3>
        <ul>
          <li>
            Tucson Pathways was a bar-napkin idea that has been built into a proof-of-concept web-app over the past few years -- Meaning the hardest work is already done.  
          </li>
        </ul>
      </div> -->
      <div class="chunk">
        <!-- <h3>Why we need financial support</h3>
        <ul>
          <li>
            For two years, I self-taught my way through the software to bring
            this concept to life. This was all done entirely unfunded between
            the nights and spare moments of working at a bicycle shop by day,
            and bartending at night.
          </li>
        </ul> -->
        <h6 style="font-style:italic">
          After over three years of work Tucson Pathways is launching our
          prototype map-platform. And now, both literally and figuratively, the
          Tucson community will hold this project in their hands. With support
          (financial backing and/or community partnerships), Tucson Pathways can
          grow to its next chapter. <br /><br />

          The future of this project goes so far beyond bicycle commuting.
          Addressing issues in food, water, energy, education, racial justice,
          and growing socio-economic divide are all on the radar of Tucson
          Pathways Project. I envision this map-platform as a tool to inform,
          organize, empower the Tucson community. The information *is* out
          there, it is just a matter of bringing it to our fingertips. Because
          of which, what we've done for transporation we plan on doing for all
          those above markers to make a more resilient city.

          <br /><br />
          As of now, your funds pay for (1) ongoing maintenance of the
          web-servers, (2) a pipeline of various features already in development
          (3) Fostering ongoing outreach with city leadership and local
          non-profits that. With all that said the hardest work has now been
          done -- Whatever comes next is dependant upon financial support and
          outreach.
          <br /><br />
          - Dylan Scott <br />
          Tucson Pathways Founder <br />
          public.dylanscott(at)gmail.com
        </h6>
        <br />
        <!-- City Government Officials, Local
            Bicycle Shops, Urban Planning Research Institutions, and Bicycle
            Advocates throughout Tucson and elsewhere.-->

        <form
          action="https://www.paypal.com/donate"
          method="post"
          target="_top"
        >
          <input type="hidden" name="business" value="9FMZDBDESV22S" />
          <input
            type="hidden"
            name="item_name"
            value="Support Tucson Pathways"
          />
          <input type="hidden" name="currency_code" value="USD" />
          <button id="paypalButton" class="btn btn-warning">
            Support Our Organization
          </button>
          <!-- <h6>
            we are completely unfunded -- this is a two year passion project
          </h6>
          <h6>read more here</h6> -->
        </form>
      </div>
      <!-- <div class="chunk">
        <h3>help by consulting</h3>
        <ul>
          <li>
            Our workflow If you work in web-development and are familiar with
            API calls, LEMP Architecture, Vue Framework, Java,
          </li>
          <li>
            If you have experience in
          </li>
          <li>
            The largest hinderance to riding a bike is fear brought on by a
            percieved lack of safety.
          </li>
        </ul>
      </div>
      <div class="chunk">
        <h3>help by becoming a community partner</h3>
        <ul>
          <li>
            Are you the owner/operator of a Tucson based small business or non-profit? 
          </li>
          <li>
            Lets see if there is a way we can both benifit -- and promote urban sustainability along the way. 
          </li>
        </ul>
      </div>
      <div class="chunk">
        <h3>help by pledging to commute</h3>
        <h6>1 day per week | 8 months per year | Offseting on avg</h6>
        <ul>
          <li>
            The Weather is conducive to bicycle communting 9 months out of the
            year.
          </li>
          <li>
            The vast majority of car trips are solo and within a 5 mile radius.
          </li>
          <li>
            The largest hinderance to riding a bike is fear brought on by a
            percieved lack of safety.
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {
    // HelloWorld
  }
};
</script>

<style lang="scss" scoped>
#paypalButton {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: 700;
  color: white;
  font-size: 1.3em;
  border: solid 2px white;
  background-color: #c7481c; // #007caf;
}

img.pageImages {
  width: auto;
  height: 100%; /*to preserve the aspect ratio of the image*/
}

.title {
  padding: 20px;
  color: #363636; // #007caf;
  text-align: center;
  line-height: 1;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  font-size: 2.3em; //2.7em;
  font-family: Georgia, "Times New Roman", Times, serif;

  // font-family: "Neue Helvetica W01", "Helvetica Neue", Helvetica, Arial,
  //   sans-serif;
  // border: solid 2px #ccb13d;
  // background-color: #0000009c;

  > h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
  }
}

.chunk {
  h3 {
    font-weight: 900;
  }
  margin: 0px 0px 50px 0px;
  padding: 20px;
  border: solid 4px #363636; // #308db8;
  border-radius: 10px;
  color: white;
  background-color: #00000059;
}

.subtitle {
  color: #c7481c;
  // -webkit-text-stroke-width: 1px;
  // -webkit-text-stroke-color: white;
}

.section2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 50vh;
  align-items: start;
  border: solid 1px black;
  padding: 10px;
}

.donate {
  font-family: math;
  height: calc(100vh - 50px);
  padding: 7vh 5vw 7vh 5vw;
  // background-color: #fdfdfc; //#fffbea;
}

#backgroundart {
  z-index: -1;
  position: fixed;
  top: 0px;
  bottom: 0px;
  width: 100%;
  background-image: url("../assets/Background2.png");
  background-size: cover;
  // background-repeat: no-repeat;
  // background-attachment: fixed;
}

#logo {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  position: fixed;
  z-index: 3;
  max-width: 80px;
  max-height: 80px;
  left: 10px;
  background: #363636;
  width: 14vw;
  height: 14vw;
  font-size: 2.5em;
  line-height: 2.5em;
  color: white;
  text-align: center;
  font-family: auto;
  // box-shadow: 3px 3px 6px grey;
}
</style>
